export default class ParamUtil {
    static getParamValue(param: string): string | null {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(param);
    }

    static removeParam(token1: string) {
        const url = new URL(window.location.href);
        url.searchParams.delete(token1);
        window.history.replaceState({}, '', url);

    }
}